export const requirements = {
  Mapped_Protocol_Questions: "Mapped Protocol Questions",
  Requirement_content: "Requirement content",
  Requirement_Ref: "Requirement Ref",
  Requirements: "Requirements",
  Section_Ref: "Section Ref",
  Section_Title: "Section Title",
  Standard: "Standard",
  Standard_Requirements: "Standard Requirements",
  Standards: "Standards",
  Sub_Section_Ref: "Sub Section Ref",
  Sub_Section_Title: "Sub Section Title",
} as const;
